export const toTitleCase = str => str.replace(/\w\S*/g, w => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());

export const PLAN_NAME = {
    free: "Discover",
    pro: "Habit",
    premium: "Lifestyle"
}